import { Img } from 'components/shared';
import Questions from 'components/Footer/Questions';
import * as React from 'react';
export default {
  Img,
  Questions,
  React
};